/* eslint-disable prefer-destructuring */
/* eslint-disable import/no-cycle */

import "./style.css";
import MDBox from "components/Basics/MDBox";
import MDInput from "components/Basics/MDInput";
import lod_ from "lodash";
import FormActions from "redux-react/actions/formAction";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentProfile } from "redux-react/reducers/profileReducer";
import DictionaryMenu from "pages/settings/filters/DictionaryMenu";
import SettingsActions from "redux-react/actions/settingsActions";

import { Icon, Grid, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import InputBoolean from "./Inputs/InputBoolean";
import InputDelay from "./Inputs/InputDelay";
import InputPhone from "./Inputs/InputPhone";
import InputDate from "./Inputs/InputDate";
import InputEmail from "./Inputs/InputEmail";
import InputString from "./Inputs/InputString";
import InputNumber from "./Inputs/InputNumber";
import InputCode from "./Inputs/InputCode";
import InputImageList from "./Inputs/InputImageList";
import InputCron from "./Inputs/InputCron";
import InputWebhook from "./Inputs/InputWebhook";
import InputLabel from "./Inputs/InputLabel";
import InputActions from "./Inputs/InputActions";
import MDTypography from "components/Basics/MDTypography";
import { getLabel, getLabelPath } from "helpers/dictionary";
import LittleArrayForm from "./Inputs/LittleArrayForm";

/**
 * Component for input
 */
export const FormInput = ({
	item,
	path,
	datas,
	handleChange,
	regexEmail = "",
	listOfApis = [],
	listOfDico = {},
	errorUniqueFields,
	disabled: disabledProp = false
}) => {
	const [anchorElOutput, setAnchorElOutput] = useState(null);
	const profile = useSelector(selectCurrentProfile);

	if (lod_.isEmpty(item)) {
		return null;
	}

	let type = item.type;
	let label = getLabel(item.label, profile?.language);
	let codes = item.codes || [];

	let value = lod_.get(datas, path);
	let disabled = disabledProp || !(item?.actions?.edit ?? true);
	let error = errorUniqueFields?.includes(path);

	const onChange = value => {
		handleChange(path, value);
	};

	// Add a star to the label if the field is required
	if (item.isRequired) {
		label = (
			<span>
				{label}
				<span className="mandatoryField">*</span>
			</span>
		);
	}

	switch (type) {
		case "labels":
			return (
				<InputLabel
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
					item={item}
					listOfApis={listOfApis}
					path={path}
				/>
			);
		case "cron":
			return <InputCron label={label} item={item} />;
		case "webhook":
			return <InputWebhook label={label} value={value} onChange={onChange} item={item} />;
		case "imageList":
			return (
				<InputImageList
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
					item={item}
					listOfApis={listOfApis}
					path={path}
				/>
			);
		case "boolean":
			return (
				<InputBoolean
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
				/>
			);
		case "phone":
			return (
				<InputPhone
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
				/>
			);
		case "date":
		case "datetime":
			return (
				<InputDate
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
				/>
			);
		case "email":
			return (
				<InputEmail
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
					regexEmail={regexEmail}
					item={item}
					listOfApis={listOfApis}
					path={path}
				/>
			);
		case "string":
			return (
				<InputString
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
					item={item}
					listOfApis={listOfApis}
					path={path}
				/>
			);
		case "number":
			return (
				<InputNumber
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
					item={item}
					listOfApis={listOfApis}
					path={path}
				/>
			);
		case "delay":
			return (
				<InputDelay
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
				/>
			);
		case "code":
			return (
				<InputCode
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
					codes={codes}
					path={path}
				/>
			);
		case "actions":
			return (
				<InputActions
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
					item={item}
					listOfApis={listOfApis}
					path={path}
				/>
			);

		case "dictionaryPath":
			return (
				<MDBox
					display="flex"
					flexDirection="row"
					justifyContent="space-between"
					alignItems="stretch"
					component="fieldset"
					style={{
						borderRadius: "0.375rem 0 0 0.375rem"
					}}
					className="boxInputStyle"
					borderRadius="md"
				>
					<MDBox>
						<legend
							style={{
								lineHeight: 1.5,
								fontSize: "0.875rem",
								color: "#344767",
								fontWeight: 400
							}}
						>
							{label}
						</legend>

						<MDBox>{getLabelPath(listOfDico, value, "Non défini", profile?.language)}</MDBox>
					</MDBox>
					<MDBox
						className="endButtonboxInputStyleCircle"
						display="flex"
						justifyContent="center"
						alignItems="center"
						bgColor="light"
						onClick={e => setAnchorElOutput(e.target)}
					>
						<Icon fontSize="small">menu</Icon>
					</MDBox>

					<DictionaryMenu
						placement="top"
						dictionary={listOfDico}
						anchorEl={anchorElOutput}
						handleInsertText={e => {
							setAnchorElOutput(null);
							onChange(e);
						}}
						handleClose={() => setAnchorElOutput(null)}
					/>
				</MDBox>
			);
		default:
			return (
				<MDBox mt={1}>
					<MDInput
						disabled={disabled}
						error={error}
						type={type}
						className="dialogInput"
						label={label}
						value={value}
						onChange={e => onChange(e.target.value)}
					/>
				</MDBox>
			);
	}
};
/**
 * Component for create a form from a dictionary
 */
export function LittleForm({
	// Props given by parent
	object,
	metadatasSkeleton,
	handleChange,
	level = 0,
	path = null,
	listAPIs = null,
	collapseActions = false,
	disabled = false,
	// Internal state, passed through recursion
	errorUniqueFields,
	expandedState = {},
	setExpandedState = null,
	baseDictionary = null
}) {
	const profile = useSelector(selectCurrentProfile);
	const assistantID = profile?.assistantID;

	const [regexEmail, setRegexEmail] = useState("");
	const [listOfApis, setListOfApis] = useState([]);
	const [keyDictionary, setKeyDictionary] = useState({});
	const [localExpandedState, setLocalExpandedState] = useState({});

	let keys = Object.keys(object);
	const dispatch = useDispatch();

	// Use parent state if available, otherwise use local state
	const expanded = level === 0 ? localExpandedState : expandedState;
	const setExpanded = level === 0 ? setLocalExpandedState : setExpandedState;

	useEffect(() => {
		const onSuccess = res => {
			setRegexEmail(res.regex);
		};
		const onSuccessApis = res => {
			setListOfApis(res?.apisList || []);
		};

		if (regexEmail === "") {
			dispatch(FormActions.getRegexLittleForm("email", onSuccess));
		}
		if (lod_.isEmpty(listOfApis)) {
			if (listAPIs) {
				setListOfApis(listAPIs);
			} else {
				dispatch(FormActions.getListApis(assistantID, onSuccessApis));
			}
		}
		if (lod_.isEmpty(keyDictionary)) {
			dispatch(
				SettingsActions.getDictionary("context", res =>
					setKeyDictionary({ context: res.dictionary })
				)
			);
		}
	}, []);

	// Initialize expanded state for all accordions
	useEffect(() => {
		if (level === 0) {
			const initialState = {};
			keys.forEach(key => {
				const item = object[key];
				if (item.type === "level") {
					initialState[key] = true; // defaultExpanded
				}
			});
			setExpanded(initialState);
		}
	}, []);

	const handleExpandAll = () => {
		const newState = {};
		keys.forEach(key => {
			const item = object[key];
			if (item.type === "level") {
				newState[key] = true;
			}
		});
		setExpanded(newState);
	};

	const handleCollapseAll = () => {
		const newState = {};
		keys.forEach(key => {
			const item = object[key];
			if (item.type === "level") {
				newState[key] = false;
			}
		});
		setExpanded(newState);
	};

	const handleAccordionChange = key => (event, isExpanded) => {
		setExpanded({
			...expanded,
			[key]: isExpanded
		});
	};

	const collapseButtonStyle = {
		fontSize: "0.75rem",
		color: "#9e9e9e",
		backgroundColor: "transparent",
		cursor: "pointer",
		transition: "color 0.2s",
		"&:hover": {
			color: "#616161"
		},
		userSelect: "none"
	};

	const accordionSummaryStyle = {
		padding: 1,
		margin: 0,
		minHeight: 0,
		"& .MuiAccordionSummary-content": {
			padding: 0,
			margin: 0,
			minHeight: 0
		},
		"&:hover": {
			backgroundColor: "#f8f9fa"
		},
		"&.Mui-expanded": {
			backgroundColor: "#f1f3f4",
			padding: 1,
			margin: 0,
			minHeight: 0
		},
		"&.Mui-expanded .MuiAccordionSummary-content": {
			padding: 0,
			margin: 0,
			minHeight: 0
		}
	};

	return (
		<MDBox>
			{level === 0 && collapseActions && (
				<MDBox display="flex" justifyContent="end" gap={1} mb={0.5}>
					<MDTypography variant="button" onClick={handleCollapseAll} sx={collapseButtonStyle}>
						Tout plier
					</MDTypography>
					<MDTypography variant="button" onClick={handleExpandAll} sx={collapseButtonStyle}>
						Tout déplier
					</MDTypography>
				</MDBox>
			)}
			<Grid container spacing={1}>
				{keys.map((key, index) => {
					let item = object[key];
					let display = item.display ?? true;

					const currentPath = path ? `${path}.${key}` : key;

					if (!display) return null;
					if (item.type === "level" && item.isArray === true) {
						/**
						 * Complex format is when object has sub object layers.
						 * complex -> display as classic form
						 * otherwise, display array like a csv table
						 */
						let hasComplexForm = Object.entries(item.items ?? {}).some(
							([_, subItem]) => subItem.type === "level"
						);

						return (
							<Grid size={{ md: 12 }} key={index}>
								<Accordion
									expanded={expanded[key] ?? true}
									onChange={handleAccordionChange(key)}
									sx={{
										boxShadow: "none",
										border: "1px solid #f1f3f4"
									}}
								>
									<AccordionSummary
										expandIcon={<Icon>expand_more</Icon>}
										sx={accordionSummaryStyle}
									>
										<h3 style={{ margin: 0, fontSize: "1rem", fontWeight: 900, color: "#424242" }}>
											{`${getLabelPath(
												baseDictionary ?? object,
												currentPath,
												"Non défini",
												profile?.language
											)} (${(lod_.get(metadatasSkeleton, currentPath) || []).length})`}
										</h3>
									</AccordionSummary>
									<AccordionDetails
										sx={{
											padding: "0",
											paddingTop: hasComplexForm ? "5px" : "0px",
											backgroundColor: "#fafafa"
										}}
									>
										{hasComplexForm && (
											<LittleForm
												object={item.items}
												level={level + 1}
												metadatasSkeleton={metadatasSkeleton}
												handleChange={handleChange}
												path={currentPath}
												listOfApis={listOfApis}
												errorUniqueFields={errorUniqueFields}
												expandedState={expanded}
												setExpandedState={setExpanded}
												collapseActions={collapseActions}
												baseDictionary={baseDictionary ?? object}
												disabled={disabled}
											/>
										)}
										{!hasComplexForm && (
											<LittleArrayForm
												dictionary={item.items}
												path={currentPath}
												values={lod_.get(metadatasSkeleton, currentPath) || []}
												handleChange={handleChange}
												disabled={disabled}
											/>
										)}
									</AccordionDetails>
								</Accordion>
							</Grid>
						);
					} else if (item.type === "level") {
						return (
							<Grid size={{ md: 12 }} key={index}>
								<Accordion
									expanded={expanded[key] ?? true}
									onChange={handleAccordionChange(key)}
									sx={{
										boxShadow: "none",
										border: "1px solid #f1f3f4"
									}}
								>
									<AccordionSummary
										expandIcon={<Icon>expand_more</Icon>}
										sx={accordionSummaryStyle}
									>
										<h3 style={{ margin: 0, fontSize: "1rem", fontWeight: 900, color: "#424242" }}>
											{getLabelPath(
												baseDictionary ?? object,
												currentPath,
												"Non défini",
												profile?.language
											)}
										</h3>
									</AccordionSummary>
									<AccordionDetails
										sx={{ padding: "0", paddingTop: "5px", backgroundColor: "#fafafa" }}
									>
										<LittleForm
											object={item.items}
											level={level + 1}
											metadatasSkeleton={metadatasSkeleton}
											handleChange={handleChange}
											path={currentPath}
											listOfApis={listOfApis}
											errorUniqueFields={errorUniqueFields}
											expandedState={expanded}
											setExpandedState={setExpanded}
											collapseActions={collapseActions}
											baseDictionary={baseDictionary ?? object}
											disabled={disabled}
										/>
									</AccordionDetails>
								</Accordion>
							</Grid>
						);
					} else {
						return (
							<FormInput
								key={index}
								item={item}
								listOfDico={keyDictionary}
								datas={metadatasSkeleton}
								handleChange={handleChange}
								regexEmail={regexEmail}
								path={currentPath}
								listOfApis={listOfApis}
								errorUniqueFields={errorUniqueFields}
								disabled={disabled}
							/>
						);
					}
				})}
			</Grid>
		</MDBox>
	);
}
